export enum EnumPanelGPSTabTypes {
    Actualizados = "Actualizados",
    Desactualizados = "Desactualizados",
    SinReporte = "Sin Reporte",
    Todos = "Todos"
}